import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import { list, find, save, remove } from '../../services/protocolAssignment'

function* fetchProtocolAssignmentListRefresh() {
  const fe = JSON.parse(localStorage.getItem('fetchProtocolAssignmentList'))
  if (fe == null) {
    fe.size = 1000
    fe.index = 0
    fe.searchTerm = null
    fe.orderBy = null
  }
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
  yield put({
    type: actions.LIST_PROTOCOLASSIGNMENT,
    result,
  })
}

function* fetchProtocolAssignmentList({ size, index, searchTerm, orderBy }) {
  // Load last params froom last session.
  if (!size && !index && !searchTerm && !orderBy) {
    const fe = JSON.parse(localStorage.getItem('fetchProtocolAssignmentList'))
    if (fe != null) {
      size = fe.size || 1000
      index = fe.index || 0
      searchTerm = fe.searchTerm || null
      orderBy = fe.orderBy || null
    } else {
      size = 1000
      index = 0
      searchTerm = null
      orderBy = null
    }
  }
  localStorage.setItem(
    'fetchProtocolAssignmentList',
    JSON.stringify({ size, index, searchTerm, orderBy }),
  )
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, size, index, searchTerm, orderBy)
  yield put({
    type: actions.LIST_PROTOCOLASSIGNMENT,
    result,
  })
}

function* fetchProtocolAssignmentEdit({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id)
  yield put({
    type: actions.EDIT_PROTOCOLASSIGNMENT,
    result,
  })
}

function* fetchProtocolAssignmentSave(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(save, values)
  if (result !== null) {
    if (result.status === 1) {
      notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
    } else {
      notification.error({ message: result.message })
    }
  }
  yield put({
    type: actions.SAVE_PROTOCOLASSIGNMENT_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_PROTOCOLASSIGNMENT_LIST,
  })
}

function* fetchProtocolAssignmentDelete({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, id)
  if (result !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.DELETE_PROTOCOLASSIGNMENT_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_PROTOCOLASSIGNMENT_LIST,
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_PROTOCOLASSIGNMENT_LIST, fetchProtocolAssignmentList),
    takeEvery(actions.FETCH_PROTOCOLASSIGNMENT, fetchProtocolAssignmentEdit),
    takeEvery(actions.SAVE_PROTOCOLASSIGNMENT, fetchProtocolAssignmentSave),
    takeEvery(actions.DELETE_PROTOCOLASSIGNMENT, fetchProtocolAssignmentDelete),
    takeEvery(actions.RE_FETCH_PROTOCOLASSIGNMENT_LIST, fetchProtocolAssignmentListRefresh),
  ])
}
